export const prices = [
  {
    _id: 0,
    name: {
      en: "Any",
      fr: "Tous les prix",
      ht: "Nenpòt pri",
      es: "Cualquier precio",
      pt: "Qualquer preço"
    },
    array: []
  },
  {
    _id: 1,
    name: {
      en: "$0 to $25",
      fr: "$0 à $25",
      ht: "$0 rive $25",
      es: "$0 a $25",
      pt: "$0 a $25"
    },
    array: [0, 25]
  },
  {
    _id: 2,
    name: {
      en: "$25 to $50",
      fr: "$25 à $50",
      ht: "$25 rive $50",
      es: "$25 a $50",
      pt: "$25 a $50"
    },
    array: [25, 50]
  },
  {
    _id: 3,
    name: {
      en: "$50 to $100",
      fr: "$50 à $100",
      ht: "$50 rive $100",
      es: "$50 a $100",
      pt: "$50 a $100"
    },
    array: [50, 100]
  },
  {
    _id: 4,
    name: {
      en: "$100 to $200",
      fr: "$100 à $200",
      ht: "$100 rive $200",
      es: "$100 a $200",
      pt: "$100 a $200"
    },
    array: [100, 200]
  },
  {
    _id: 5,
    name: {
      en: "$200 to $400",
      fr: "$200 à $400",
      ht: "$200 rive $400",
      es: "$200 a $400",
      pt: "$200 a $400"
    },
    array: [200, 400]
  },
  {
    _id: 6,
    name: {
      en: "$400 to $800",
      fr: "$400 à $800",
      ht: "$400 rive $800",
      es: "$400 a $800",
      pt: "$400 a $800"
    },
    array: [400, 800]
  },
  {
    _id: 7,
    name: {
      en: "$800 to $1600",
      fr: "$800 à $1600",
      ht: "$800 rive $1600",
      es: "$800 a $1600",
      pt: "$800 a $1600"
    },
    array: [800, 1600]
  },
  {
    _id: 8,
    name: {
      en: "$1600 to $3200",
      fr: "$1600 à $3200",
      ht: "$1600 rive $3200",
      es: "$1600 a $3200",
      pt: "$1600 a $3200"
    },
    array: [1600, 3200]
  },
  {
    _id: 9,
    name: {
      en: "More than $3200",
      fr: "Plus de $3200",
      ht: "Plis pase $3200",
      es: "Más de $3200",
      pt: "Mais de $3200"
    },
    array: [3200, 100000000]
  }
];